<template>
    <HeaderList></HeaderList>
    <div class="movie relative pt-24 h-full bg-theme-gray">
        <MovieView></MovieView>
    </div>
</template>

<script>
import HeaderList from '@/components/HeaderList.vue';
import MovieView from '@/components/MovieView.vue';

export default {
    name: 'Movie',
    components: {
        HeaderList,
        MovieView
    }
};
</script>